export default __webpack_public_path__ + "static/media/0247.bd813ce5.jpg";